export interface Section extends QuickLinkBase {
  industry: string;
  oldIndustry: string;
  portalName: string;
  oldPortalName: string;
  webSectionParentName: string;
  oldWebSectionParentName: string;
  webSectionName: string;
  webSectionDisplayName: string;
  webSectionDisplayOrder: string;
  oldWebSectionDisplayOrder: string;
  webSectionURL: string;
  webSectionSKFOnly: boolean;
  powerBIReportName: string;
  oldPowerBIReportName: string;
  powerBIReportDefaultPage: string;
  powerBIReportDisplayTabs: boolean;
  addQuickLinks: boolean;
  userWebFeatureGrant: string;
  userWebRoleName: string;
  quickLinkS3URL: string;
  sectionFilterList?: SectionFilter[];  
}

export interface QuickLinkBase {
  quickLinkTextDisplay: string;
  quickLinkDescription: string;
}

export interface SectionTableSectionInfo {
  industryInformation: SectionIndustryInfo[];
  sectionTableInformationDTO: SectionTable[];
  filterType: SectionIndustryInfo[];
}

export interface SectionTable {
  industry: string;
  portalName: string;
  webSectionParentName: string;
  webSectionURL: string;
  powerBIReportName: string;
  webSectionName: string;
  userWebRole: string;
  quickLinkImageName: string;
  userWebFeatureGrant: string;
  webFeatureRoleGrants: string;
}

export interface DeleteSection {
  industry: string;
  portalName: string;
  webSectionName: string;
  quickLinkName: string;
}

export interface SectionIndustryInfo {
  industry: string;
  portalInformation: SectionPortalInfo[];
}

export interface SectionPortalInfo {
  portalName: string;
  webSectionName: SectionPortalSectionInfo[];
}

export interface SectionPortalSectionInfo {
  webSectionParentDisplayName: string;
  webSectionParentId: string;
}

export interface ImageType {
  id: string;
  preview?: string;
  raw?: File;
  title: string;
  added?: boolean;
}

export const AcceptedImgTypes: string[] = [
  '.bmp',
  '.gif',
  '.jpeg',
  '.pbm',
  '.png',
  '.tiff',
  '.tga',
  '.webp',
  '.jpg',
];

export enum SectionFormMode {
  EDIT,
  ADD,
  DELETE,
}

export const getEmptySection = (): Section => {
  return {
    industry: '',
    oldIndustry: '',
    portalName: '',
    oldPortalName: '',
    webSectionName: '',
    webSectionParentName: '',
    oldWebSectionParentName: '',
    webSectionDisplayName: '',
    webSectionURL: '',
    webSectionSKFOnly: false,
    powerBIReportName: '',
    oldPowerBIReportName: '',
    powerBIReportDefaultPage: '',
    powerBIReportDisplayTabs: false,
    addQuickLinks: false,
    quickLinkTextDisplay: '',
    quickLinkDescription: '',
    userWebFeatureGrant: '',
    userWebRoleName: '',
    webSectionDisplayOrder: '0',
    oldWebSectionDisplayOrder: '0',
    quickLinkS3URL: '',
    sectionFilterList: [],
  };
};

export interface SectionFilter {
  webSectionFilterName: string;
  webSectionFilterPowerBiTableName: string;
  webSectionFilterPowerBiFieldName: string;
  webSectionFilterTypeDescription: string;
  webSectionFilterTypeCode: string;
  webSectionSnowflakeTableName: string;
  webSectionSnowflakeColumnName: string;
  webSectionSingleSelectFlag: boolean;
  webSectionSearchFlag: boolean;
}

export interface SectionFilterTableData extends Omit<SectionFilter, 'webSectionSingleSelectFlag' | 'webSectionSearchFlag'> {
  webSectionSingleSelectFlag: string;
  webSectionSearchFlag: string;
}

export interface SectionFilterFilterType {
  filterTypeCode: string;
  filterTypeDescription: string;
}

export const createEmptySectionFilter = (): SectionFilter => {
  return {
    webSectionFilterName: '',
    webSectionFilterPowerBiTableName: '',
    webSectionFilterPowerBiFieldName: '',
    webSectionFilterTypeCode: '',
    webSectionFilterTypeDescription: '',
    webSectionSnowflakeTableName: '',
    webSectionSnowflakeColumnName: '',
    webSectionSingleSelectFlag: false,
    webSectionSearchFlag: false,
  };
};
